// Глобальный listener create-from-chat *:ready / *:failed + reconcile poll.
// Монтируется в __root рядом с NotificationToastListener — не зависит от
// TutorSidePanel (на /tutor/$sessionId панель закрыта, но listeners нужны).

import { useCreateFromChatReadyToasts } from "./create-from-chat-pending";

export function CreateFromChatReadyListener() {
	useCreateFromChatReadyToasts();
	return null;
}
